import { defaultApiState } from '../api.state';

export const purchaseMutations = {
  GET_PURCHASES_LOADING(state) {
    state.apiState.getPurchases = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_PURCHASES_SUCCESS(state, payload) {
    state.apiState.getPurchases = {
      ...defaultApiState,
      success: true,
    };
    state.purchases = payload;
  },
  GET_PURCHASES_ERROR(state, error) {
    state.apiState.getPurchases = {
      ...defaultApiState,
      error,
    };
  },
  GET_PURCHASE_LOADING(state) {
    state.apiState.getPurchase = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_PURCHASE_SUCCESS(state, payload) {
    state.apiState.getPurchase = {
      ...defaultApiState,
      success: true,
    };
    state.purchase = payload;
  },
  GET_PURCHASE_ERROR(state, error) {
    state.apiState.getPurchase = {
      ...defaultApiState,
      error,
    };
  },
};
